<template>
    <v-card class="notes-page pa-7 pb-1 mt-8 mb-16 pb-8" style="border-radius: 10px; max-width: 600px;" flat>
        <v-card-text class='mt-5'>
            <div
                class='mb-7 d-flex flex-nowrap'
                @click='$router.go(-1)'
            >
                <v-icon size="22" class='mr-2'> mdi-arrow-left-circle</v-icon>
                <div class='event-card__link'>Notes</div>
            </div>
            <div class='notes-page__header'>
                <h2 class="notes-page__title">
                    Choose a Person
                </h2>
                <div class="d-flex justify-space-between notes-search__wrapper">
                    <div class="d-flex w-100 pr-3 align-center notes-search__input">
                        <input
                            type="text"
                            class="px-3 py-2"
                            placeholder="Search"
                            v-model="filters.search"
                            @input="filterSearch"
                            style="outline: none"
                        />
                        <img :src="searchIcon" alt="" />
                    </div>
                </div>
            </div>

            <div>
                <v-skeleton-loader
                    v-if='isLoading'
                    type='list-item-avatar, list-item-avatar, list-item-avatar'
                ></v-skeleton-loader>
                <div v-else>
                    <UserAddNoteItem 
                        v-for="user in users" 
                        :key="user.user_id"
                        :user="user"
                        :selectedUser="selectedUser"
                        v-on:selectUser="selectUser"
                    />
                </div>
            </div>

            <div class='d-flex my-9 justify-center notes-page__pagination'
                v-if='!isLoading && users.length > 0'
            >
                <Pagination 
					:page="filters.page"
					:pageCount="+this.pageCountAttendees"
					v-on:pageChange="onPageChange"
				/>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import searchIcon from '@/assets/images/search.svg'
import UserAddNoteItem from '@/components/Profile/UserAddNoteItem.vue'
import Pagination from '@/components/Pagination.vue'

const DEBOUNCE_TIMEOUT = 500

export default {
    components: {
        UserAddNoteItem,
        Pagination
    },
    data() {
        return {
            searchIcon,
            filters: {
                page: 1,
                search: '',
            },
            selectedUser: null
        }
    },
    computed: {
        ...mapGetters('event', ['isLoading', 'pageCountAttendees', 'attendees']),

        users() {
            return this.attendees
        }
    },
    methods: {
        ...mapActions('event', ['getAttendeesEvent', 'clearAttendeesEvent']),

        filterSearch(e) {
            clearTimeout(this.timer)

            this.filters.page = 1

            this.timer = setTimeout(() => {
                this.getAttendeesEvent(`page=${1}&search=${e.target.value}`)
            }, DEBOUNCE_TIMEOUT)
        },

        onPageChange(page) {
            if (page !== this.filters.page) {
                this.filters.page = page
                this.getAttendeesEvent(`page=${page}&search=${this.filters.search}`)
            }
        },
        selectUser(user) {
            this.selectedUser = user
        }
    },
    watch: {
        'filters.page': function (newValue, oldValue) {
            newValue !== oldValue && this.onPageChange(newValue)
        }
    },
    created() {
        this.getAttendeesEvent()
    },
    beforeDestroyed() {
        this.clearAttendeesEvent()
    }
}
</script>

<style lang="scss">
</style>